// The referral code a visitor arrived with (/r/:code), kept until the account
// that code should bind is created. The backend binds it only at account
// creation and only once (wiki/plans/REWARDS-API.md, "Referral code at
// signup"); here it is just carried to the creating POST.
//
// Every storage access is wrapped: localStorage can be absent, blocked or full
// (private mode, Telegram WebView, node tests), and a referral must never break
// the page or the signup.

export const REFERRED_BY_KEY = 'wt:referred-by:v1'

// One code rule on both sides: the same pattern as CODE_RE in
// components/rewards/Referrals.tsx, the backend's NormalizeReferralCode and the
// CHECK on userland_referral_codes.code (lowercase [a-z0-9-], 3–20, no dash at
// either end). referredBy.test.ts keeps the two frontend copies equal.
export const REFERRAL_CODE_RE = /^[a-z0-9](?:[a-z0-9-]{1,18})[a-z0-9]$/

/** Lowercased, trimmed code when it satisfies the rule; null otherwise. Nothing
 *  is stripped, so a garbled code is dropped rather than turned into another. */
export function cleanReferralCode(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null
  const code = raw.trim().toLowerCase()
  return REFERRAL_CODE_RE.test(code) ? code : null
}

export function readReferredBy(): string | null {
  try {
    return cleanReferralCode(localStorage.getItem(REFERRED_BY_KEY))
  } catch {
    return null
  }
}

/** Stores a valid code (the latest invite followed wins); false when the code
 *  breaks the rule or storage refuses it. */
export function writeReferredBy(raw: string): boolean {
  const code = cleanReferralCode(raw)
  if (!code) return false
  try {
    localStorage.setItem(REFERRED_BY_KEY, code)
    return true
  } catch {
    return false
  }
}

export function clearReferredBy(): void {
  try {
    localStorage.removeItem(REFERRED_BY_KEY)
  } catch {
    // storage unavailable: nothing to clear
  }
}
